import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const endPoint = `${baseUrl}/termsandconditions`;

export const getAcceptanceStatus = () => {
    return http.get(`${endPoint}/acceptance-status`);
};
export const getAnalytics = () => {
    return http.get(`${endPoint}/analytics`);
};
export const getAll = () => {
    return http.get(`${endPoint}/admin/all`);
};
export const getActive = () => {
    return http.get(`${endPoint}/active`);
};
export const getAcceptanceHistory = () => {
    return http.get(`${endPoint}/acceptance-history`);
};
export const create = (payload, file) => {
    const formData = new FormData();
    formData.append('payload', JSON.stringify(payload));
    if (file) {
        formData.append('file', file);
    }
    return http.post(`${endPoint}`, formData);
};
export const acceptTerms = (payload) => {
    return http.post(`${endPoint}/accept`, payload);
};
